import { PublicClientApplication } from '@azure/msal-browser';

import { msalConfig } from './msalAuthConfigs';

/**
 * The single MSAL instance for the app.
 *
 * Kept in its own module (rather than in `src/index.tsx`) so non-UI modules — `utils/request`,
 * `services/callApi`, the store middleware — can use it without importing the application entry
 * point (which pulls in fonts, global styles and `App`). That import chain previously made these
 * modules untestable in isolation.
 */
export const msalInstance = new PublicClientApplication(msalConfig);
